import { IMec } from './filters'

export class Stats {
    count: string
    maxRQ: string
    meanRQ: string
    rq95: string
    medianRQ: string
    substances: string

    // TODO: add type
    constructor(mecsFiltered: IMec[], pnecsFiltered: any) {
        // @ts-ignore
        const rqSorted = mecsFiltered.map(o => o.rq).sort((a, b) => a - b) as number[]
        this.count = mecsFiltered.length.toString()
        this.maxRQ = this.getMax(rqSorted)
        this.meanRQ = this.getMean(rqSorted)
        this.rq95 = this.getPercentile(rqSorted, 0.95)
        this.medianRQ = this.getPercentile(rqSorted, 0.5)
        this.substances = Object.keys(pnecsFiltered).length.toString()
    }
    
    // getPercentile calculates the index that corresponds to the desired percentile within the sorted array using 
    // Math.round(sortedArray.length * decimal) - 1. 
    // (The - 1 is used to adjust from the position in the number line to the index in the array (which is 0-based))
    // It then uses this value to retrieve the value (at the calculated percentile index) from the sortedArray using sortedArray[<RESULT>].
    // Note: This does not return a mathamatical calculated percentile, but instead the value at the percentile position in the data array
    
    getPercentile(sortedArray: number[], decimal: number) {
        if (!(sortedArray.length > 0)) {
            return ""
        }
        // We subtract 1 to go from position in number line to array position
        const result = sortedArray[(Math.round(sortedArray.length * decimal) - 1)]
        return this.significise(result)
    }

    // getMax calculates the maximum value in the array using the Math.max(...arr) function call. 
    // The spread operator (...) is used to spread the array elements as individual arguments to the Math.max function.
    getMax(arr: number[]) {
        return (arr.length > 0) ? this.significise(Math.max(...arr)) : ""
    }

    // getMean calculates the mean (average) of the numbers in the array. 
    // This is done by using the reduce method to sum up all the numbers in the array (arr.reduce((a, b) => a + b, 0)), 
    // and then dividing the sum by the length of the array (arr.length).
     getMean(arr: number[]) {
        return (arr.length > 0) ? this.significise(arr.reduce((a, b) => a + b, 0) / arr.length) : ""
    }

    significise(val: number) {
        return parseFloat(val.toPrecision(3)).toString()
    }
}